var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6095 7.77598C14.0345 5.1766 13.1817 3.51848 11.8148 3.11442C11.5501 3.03719 11.2756 2.99867 10.9998 3.00004C10.1595 3.00004 9.49637 3.50004 7.99981 3.50004C6.50325 3.50004 5.83887 3.00004 4.99981 3.00004C4.71255 2.99855 4.42647 3.03705 4.14981 3.11442C2.78106 3.51848 1.93544 5.17817 1.35387 7.77598C0.760125 10.4294 0.867625 12.526 2.02825 12.9285C2.84075 13.2097 3.56731 12.6282 4.25544 11.7722C5.03669 10.7972 5.99887 10.4972 7.99981 10.4972C10.0007 10.4972 10.9254 10.7972 11.7079 11.7722C12.3954 12.6288 13.1489 13.2032 13.9398 12.9335C15.2217 12.4957 15.2036 10.4607 14.6095 7.77598Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 7.625C9.47018 7.625 9.75 7.34518 9.75 7C9.75 6.65482 9.47018 6.375 9.125 6.375C8.77982 6.375 8.5 6.65482 8.5 7C8.5 7.34518 8.77982 7.625 9.125 7.625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.00001C10.3763 9 10.2554 8.96331 10.1526 8.89456C10.0498 8.82582 9.96968 8.72811 9.92243 8.61382C9.87517 8.49952 9.86288 8.37378 9.88712 8.2525C9.91137 8.13121 9.97105 8.01985 10.0586 7.93251C10.1462 7.84516 10.2577 7.78576 10.379 7.76182C10.5004 7.73788 10.6261 7.75048 10.7403 7.79803C10.8544 7.84557 10.9519 7.92592 11.0204 8.02891C11.0889 8.13189 11.1253 8.25288 11.125 8.37656C11.1246 8.54205 11.0586 8.70063 10.9414 8.8175C10.8242 8.93437 10.6655 9.00001 10.5 9.00001Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.25C10.8452 6.25 11.125 5.97018 11.125 5.625C11.125 5.27982 10.8452 5 10.5 5C10.1548 5 9.875 5.27982 9.875 5.625C9.875 5.97018 10.1548 6.25 10.5 6.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7.625C12.2202 7.625 12.5 7.34518 12.5 7C12.5 6.65482 12.2202 6.375 11.875 6.375C11.5298 6.375 11.25 6.65482 11.25 7C11.25 7.34518 11.5298 7.625 11.875 7.625Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5V8.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7H3.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.4e3fa6c11c384a3d8cd2ccf249cc920a.svg";
export { ForwardRef as ReactComponent };